import React, { useContext } from "react";
import { ThemeContext } from "../../context";
import "./footer.css";
const Footer = () => {
  const theme = useContext(ThemeContext);
  const dark = theme.state.darkMode;
  return (
    <div
      className="footer"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: dark ? "#222" : "white",
        color: dark ? "white" : "black",
        boxShadow: "0px -2px 9px 1px rgba(168,168,168,0.75)",
        webkitBoxShadow: "0px -2px 9px 1px rgba(168,168,168,0.75)",
        mozBoxShadow: "0px -2px 9px 1px rgba(168,168,168,0.75)",
      }}
    >
      <p style={{ fontSize: "16px", fontWeight: "bold", fontStyle: "italic" }}>
        Rahmat @ 2022
      </p>
    </div>
  );
};

export default Footer;
